import type { QrParseResult } from './qr';

/**
 * Where a recognised scan goes. 'charge' is the scanner's normal job - the
 * pre-session page - and is exactly the parsed path, unchanged. 'fob' is
 * the fob self-registration mode (/scan?for=fob, F3): a stall code carries
 * the charger identity to /my-fobs, where the server checks the charger is
 * live and Preparing; a station-only code names no charger, so the driver
 * is told to scan the one on the charger itself.
 *
 * Its own module, importing qr.ts for the TYPE only: qr.ts reads Vite's
 * import.meta.env at load, which node:test cannot provide.
 */
export type ScanDestination =
  | { kind: 'navigate'; path: string }
  | { kind: 'stationOnly' }
  | { kind: 'none' };

export function scanDestination(parsed: QrParseResult, mode: 'charge' | 'fob'): ScanDestination {
  if (parsed.kind === 'unknown') return { kind: 'none' };
  if (mode === 'charge') return { kind: 'navigate', path: parsed.path };
  if (parsed.kind === 'stall') {
    return { kind: 'navigate', path: `/my-fobs?charger=${encodeURIComponent(parsed.chargerIdentity)}` };
  }
  return { kind: 'stationOnly' };
}
